
import apiService from "./apiService";

const sellerAccountService = {
    updateSellerAccountProfile: async (firstName: string, lastName: string, contactNumber: string, timezone: string, countryCode:string) => {
        return await apiService.put(`/SellerAccount/Profile`, { firstName: firstName, lastName: lastName, contactNumber: contactNumber, timezone: timezone, countryCode:countryCode });
    },
    updateSellerAccountPassword: async (oldPassword: string, newPassword: string) => {
        return await apiService.put(`/SellerAccount/Password`, { oldPassword: oldPassword, newPassword: newPassword });
    },
    /**
     * 
     * @returns "TooFrequent", "EmailFailed", "Success" and "Error".
     */
    sendEmailVerification: async () => {
        return await apiService.post(`/SellerAccount/EmailVerification`, null);
    },
    /**
     * 
     * @param token 
     * @returns "InvalidToken", "TokenExpired", "Success" and "Error"
     */
    verifyEmail: async (token: string) => {
        return await apiService.put(
        `/SellerAccount/EmailVerified`,
        `"${token}"`, // wrap token in quotes so it's valid JSON
        {
            headers: {
                'Content-Type': 'application/json'
            }
        }
    );
    }
}
export default sellerAccountService;